import React from 'react';
import DetailsPopUpContent from 'shared/components/details-pop-up-content/details-pop-up-content';

import { useSystemsContextProvider } from 'features/systems/context/systems-provider';
import { SystemType } from 'features/systems/domain/models/system';
import SystemConfiguration from 'features/systems/views/details/system-configuration';
import SystemDetailsPopupHeader from 'features/systems/views/details/system-details-popup-header';
import SystemInformation from 'features/systems/views/details/system-information';
import useSystemDetailsContent from './hooks';

type Props = {
  systemType: SystemType;
};

const SystemDetailsContent = ({ systemType }: Readonly<Props>): React.JSX.Element => {
  const { systemsDetailsHook } = useSystemsContextProvider();
  const { form } = systemsDetailsHook;
  const { handleSubmitForm, resetForm } = useSystemDetailsContent(systemType);

  return (
    <DetailsPopUpContent
      onSubmit={form.handleSubmit(handleSubmitForm)}
      header={<SystemDetailsPopupHeader resetForm={resetForm} />}
      leftContent={<SystemInformation />}
      rightContent={<SystemConfiguration />}
    />
  );
};

export default SystemDetailsContent;
